import React, { PureComponent } from "react";
import { changeLocation } from "api/Location";
import { isNil } from "lodash";
import { pure } from "recompose";
import { withRouter } from "react-router";

import { roleToUrl } from "services/utils";
import DecisionsSummary from "containers/decisions-summary";
import Countdown from "components/countdown";
import Auth from "routes/Auth";

import { view } from "@risingstack/react-easy-state";
import RoundSwitcherList from "./RoundSwitcherList";
import LinksWrapper from "./LinksWrapper";

import cn from 'classnames';

const InstructorLeftBar = pure(props => {
  const {
    location,
    instructorRounds,
    currentRound,
    roundInUrl,
    rounds,
    isMenuExpanded,
    isPerformanceFeedbackVisible,
    //finishedSurveys
  } = props;
  const round = isNil(roundInUrl) ? currentRound : roundInUrl;
  const temporaryUser = Auth.getTemporaryUser();

  /*const finishedSurveysSublinks = finishedSurveys.map(finishedSurvey => (
    {
      to: `/instructor/peer-feedback/`,
      title: finishedSurvey.stage.charAt(0).toUpperCase() + finishedSurvey.stage.slice(1),
      round,
      alignCenter: true,
      params: [{ name: 'survey', value: finishedSurvey.stage }]
    }
  ));*/

  const activeRound = rounds.find(item => item.number === round);
  const isActiveRoundFinished = activeRound ? activeRound.is_finished : false;

  return (
    <div className={cn('left__bar', {
      left__bar__collapsed: !isMenuExpanded,
    })}>
      <div className="left__bar__div">
        <RoundSwitcherList
          round={round}
          currentRound={currentRound}
          rounds={instructorRounds}
          location={location}
          isMenuExpanded={isMenuExpanded}
        />
        <Countdown
          currentRound={currentRound}
          rounds={instructorRounds}
          roundInUrl={roundInUrl}
          isMenuExpanded={isMenuExpanded}
        />
        <LinksWrapper
          isMenuExpanded={isMenuExpanded}
          location={location}
          links={[
            {
              to: "/instructor/dashboard",
              hide: !!temporaryUser,
              round,
              title: "Dashboard"
            },
            {
              to: '/instructor/welcome',
              title: 'Welcome',
              hide: !!temporaryUser,
              round,
              innerLinks: [
                {
                  to: '/instructor/onboarding',
                  title: 'Onboarding',
                  round,
                },
                {
                  to: '/analysis/bcase',
                  title: 'The Business Case',
                  round,
                },
                {
                  to: '/ceo/analysis/market',
                  title: 'Customer Analysis',
                  round,
                },
                {
                  to: '/instructor/goals-and-targets',
                  title: 'Goals & Targets',
                },
              ],
            },
            {
              to: '/instructor/game-setup',
              title: 'Game Admin',
              hide: !!temporaryUser,
              round,
              innerLinks: [
                {
                  to: '/instructor/teams-roles',
                  title: 'Teams & Roles',
                },
                {
                  to: '/instructor/rounds',
                  title: 'Rounds',
                  round,
                },
                {
                  to: '/instructor/peer-review',
                  title: 'Peer Review',
                  round,
                },
                {
                  to: '/instructor/grading',
                  title: 'Grading',
                  round,
                },
              ],
            },
            {
              to: '/instructor/monitoring',
              title: 'Monitoring',
              hide: !temporaryUser,
              round,
              innerLinks: [
                {
                  to: "/decisions/ceo",
                  round,
                  title: "CEO Decisions"
                },
                {
                  to: "/decisions/product-development",
                  round,
                  title: "Product Management"
                },
                {
                  to: "/decisions/product-marketing",
                  round,
                  title: "Product Marketing"
                },
                {
                  to: "/decisions/operations",
                  round,
                  title: "Operations Decisions"
                },
                {
                  to: "/decisions/finance",
                  round,
                  title: "Finance Decisions"
                },
                {
                  to: '/ceo/audit-trail',
                  alternatives: [
                    '/pd/audit-trail',
                    '/pm/audit-trail',
                    '/op/audit-trail',
                    '/fn/audit-trail',
                  ],
                  title: 'Audit Trail',
                  round,
                },
              ],
            },
            {
              to: '/instructor/results',
              title: 'Results',
              hide: !!temporaryUser,
              round,
              innerLinks: [
                ...(isPerformanceFeedbackVisible ? [
                  {
                    to: '/instructor/performance-feedback',
                    title: 'Performance Feedback',
                    round,
                  }
                ] : []),
                {
                  to: '/instructor/final-scores',
                  title: 'Final Scores',
                  round,
                },
              ],
            },
            {
              to: '/instructor/results',
              title: 'Results',
              hide: (!temporaryUser || !isActiveRoundFinished),
              innerLinks: [
                {
                  to: '/analysis/team-reports',
                  title: 'Team Reports',
                  round,
                },
              ],
            },
          ]}
        />
      </div>
    </div>
  );
});

const LeftBar = pure(({ isStudent, ...props }) =>
  isStudent ? <StudentLeftBar {...props} /> : <InstructorLeftBar {...props} />
)

class StudentLeftBar extends PureComponent {
  constructor(props) {
    super(props);

    const { pathname } = props.location;

    this.state = {
      showMenu: false,
      showNavigation: false,
      showTeamReportsMenu:
        [
          "/analysis/bcase",
          "/ceo/analysis/market",
          "/pd/analysis/market",
          "/pm/analysis/market",
          "/op/analysis/market",
          "/fn/analysis/market",
          "/team-reports"
        ].includes(pathname) ||
        pathname.indexOf("/analysis/team-reports") === 0,
      showDecisionsMenu: [
        "/decisions/ceo",
        "/decisions/product-development",
        "/decisions/product-marketing",
        "/decisions/operations",
        "/decisions/finance"
      ].includes(pathname)
    };
  }

  showDecisionsMenu = e => {
    e.preventDefault();

    this.setState(
      {
        showDecisionsMenu: true
      },
      () => {
        document.addEventListener("click", this.hideDecisionsMenu);
      }
    );
  };

  hideDecisionsMenu = e => {
    if (e.target.toString().indexOf("decisions") > -1) {
      return;
    } else {
      this.setState(
        {
          showDecisionsMenu: false
        },
        () => {
          document.removeEventListener("click", this.hideDecisionsMenu);
        }
      );
    }
  };

  showTeamReportsMenu = event => {
    event.preventDefault();

    this.setState(
      {
        showTeamReportsMenu: true
      },
      () => {
        document.addEventListener("click", this.closeTeamReports);
      }
    );
  };

  closeTeamReports = e => {
    if (
      e.target.toString().indexOf("analysis") > -1 ||
      e.target.toString().indexOf("team-reports") > -1
    ) {
      return;
    } else {
      this.setState({ showTeamReportsMenu: false }, () => {
        document.removeEventListener("click", this.closeTeamReports);
      });
    }
  };

  showMenu = event => {
    event.preventDefault();

    this.setState(
      {
        showMenu: true
      },
      () => {
        document.addEventListener("click", this.closeMenu);
      }
    );
  };

  closeMenu = () => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener("click", this.closeMenu);
    });
  };

  renderYears() {
    const { years, currentRound } = this.props;

    if (years.data.length > 0) {
      years.data.map(el => {
        return <li>Year : {el <= currentRound ? el : ""}</li>;
      });
    } else {
      return <li>Year : {years.data[0]}</li>;
    }
  }

  showPositionsMenu = event => {
    event.preventDefault();

    const { position } = this.props;

    const route = `/decisions/${position.toString().toLowerCase()}`;
    changeLocation(route);

    this.setState(
      {
        showNavigation: true
      },
      () => {
        document.addEventListener("click", this.closePositionsMenu);
      }
    );
  };

  closePositionsMenu = e => {
    if (e.target.toString().indexOf("decisions") > -1) {
      return;
    } else {
      this.setState({ showNavigation: false }, () => {
        document.removeEventListener("click", this.closePositionsMenu);
      });
    }
  };

  render() {
    const {
      currentRound,
      rounds,
      roundInUrl,
      position,
      location,
      isNextStepsVisited,
      isMenuExpanded,
      hasTrivia,
      isPeerReviewVisible,
      isPerformanceFeedbackVisible
    } = this.props;

    const round = isNil(roundInUrl) ? currentRound : roundInUrl;
    const roleUrl = roleToUrl(position);

    return (
      <div className={cn('left__bar', {
        left__bar__collapsed: !isMenuExpanded,
      })}>
        <div className="left__bar__div">
          <RoundSwitcherList
            round={round}
            currentRound={currentRound}
            rounds={rounds}
            location={location}
            isMenuExpanded={isMenuExpanded}
          />
          <Countdown
            currentRound={currentRound}
            rounds={rounds}
            roundInUrl={roundInUrl}
            isMenuExpanded={isMenuExpanded}
          />
          <LinksWrapper
            currentRound={currentRound}
            roundInUrl={roundInUrl}
            position={position}
            location={location}
            isMenuExpanded={isMenuExpanded}
            links={[
              /*{
                to: "/dashboard",
                round,
                title: "Dashboard",
                hide: false
              },*/
              {
                to: '/onboarding',
                round,
                title: 'Welcome',
                hide: false,
              },
              {
                to: `/expand/research`,
                round: round,
                hide: !isNextStepsVisited || round === 1,
                title: "Research",
                innerLinks: [
                  {
                    to: `/analysis/bcase`,
                    round: round,
                    title: "Business Case"
                  },
                  {
                    to: `/${roleUrl}/analysis/market`,
                    round: round,
                    title: "Customer Analysis"
                  },
                  {
                    to: "/analysis/team-reports",
                    round: round - 1,
                    title: "Prior Round Team Report",
                  },
                ],
              },
              {
                to: `/expand/research`,
                round: round,
                hide: !isNextStepsVisited || round !== 1,
                title: "Research",
                innerLinks: [
                  {
                    to: `/analysis/bcase`,
                    round: round,
                    title: "Business Case"
                  },
                  {
                    to: `/${roleUrl}/analysis/market`,
                    round: round,
                    title: "Customer Analysis",
                  },
                ],
              },
              {
                to: '/goals-and-targets',
                round,
                title: 'Goals & Targets',
                hide: !isNextStepsVisited,
              },
              {
                to: '/round-trivia',
                round,
                title: 'Trivia',
                hide: !isNextStepsVisited || !hasTrivia,
              },
              {
                to: "/expand/decisions",
                round: round,
                title: "Decisions",
                hide: !isNextStepsVisited,
                innerLinks: [
                  {
                    to: "/decisions/ceo",
                    round: round,
                    title: "CEO",
                  },
                  {
                    to: "/decisions/product-development",
                    round: round,
                    title: "Product Management",
                  },
                  {
                    to: "/decisions/product-marketing",
                    round: round,
                    title: "Product Marketing",
                  },
                  {
                    to: "/decisions/operations",
                    round: round,
                    title: "Operations",
                  },
                  {
                    to: "/decisions/finance",
                    round: round,
                    title: "Finance",
                  },
                ],
              },
              ...(isPeerReviewVisible ? [
                {
                  to: "/peer-review",
                  title: "Peer Review",
                  round: round,
                  hide: !isNextStepsVisited,
                }
              ] : []),
              {
                to: "/expand/results",
                round: round,
                title: 'Results',
                hide: !isNextStepsVisited,
                innerLinks: [
                  ...(isPerformanceFeedbackVisible ? [
                    {
                      to: "/performance-feedback",
                      round: round,
                      title: "Performance Feedback",
                    },
                  ] : []),
                  {
                    to: "/analysis/team-reports",
                    round: round,
                    title: "Team Report",
                  },
                  {
                    to: "/scoring-breakdown",
                    round: round,
                    title: "Scoring Breakdown",
                  },
                ],
              },
              // {
              //   to: "/ceo/knowledge-base",
              //   round: round,
              //   title: "Knowledge Base",
              //   hide: !isNextStepsVisited,
              // },
            ]}
          />
          {this.state.showNavigation ? (
            <DecisionsSummary location={window.location} position={position} />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(view(LeftBar));



// WEBPACK FOOTER //
// ./src/components/navigation/leftbar/index.js